import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import {
  TabsModule,
  TypeaheadModule,
  AccordionModule,
  BsDropdownModule,
  BsDatepickerModule,
  TooltipModule,
  PaginationModule,
  SortableModule,
} from 'ngx-bootstrap';

const bootstrapStuff = [
  NgxPaginationModule,
  TypeaheadModule,
  AccordionModule,
  BsDropdownModule,
  BsDatepickerModule,
  TooltipModule,
  TabsModule,
  PaginationModule,
  SortableModule,
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ...bootstrapStuff,
  ],
  exports: [
    ...bootstrapStuff,
  ],
  providers: [],
})
export class NGXBootstrapModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: NGXBootstrapModule,
      providers: [
        TypeaheadModule.forRoot().providers,
        AccordionModule.forRoot().providers,
        BsDropdownModule.forRoot().providers,
        BsDatepickerModule.forRoot().providers,
        TooltipModule.forRoot().providers,
        TabsModule.forRoot().providers,
        PaginationModule.forRoot().providers,
        SortableModule.forRoot().providers,
      ],
    };
  }
}
